module.exports = __webpack_public_path__ + "img/CM-SL-CA-Infiniti-Established.bb204288.jpeg";